import { render, staticRenderFns } from "./CriteriaTypeSave.vue?vue&type=template&id=2d3b61e0&"
import script from "./CriteriaTypeSave.vue?vue&type=script&lang=js&"
export * from "./CriteriaTypeSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports